import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Dashboard insight callout — cream strip used across Overview / Trends /
 * Products / Events / Venues for a consistent highlight treatment.
 */
export function DashboardInsightChip({ title, detail, className }) {
  if (!title) return null;

  return (
    <div
      className={cn(
        'flex flex-col gap-0.5 rounded-xl border border-amber-200/80 bg-[#F8F1E3] px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between sm:gap-4',
        className
      )}
      role="status"
    >
      <p className="text-sm font-semibold leading-snug text-[#5D2E17]">{title}</p>
      {detail ? (
        <p className="shrink-0 text-xs font-medium text-[#595959] sm:text-right">{detail}</p>
      ) : null}
    </div>
  );
}
